import { motion } from 'framer-motion';
import React from 'react';
import MagentaLine from '../elements/MagentaLine';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/bh-polaris-bg.mp4';

export default function NewPolaris() {
  const BASE_TIME = 2;
  const INTERVAL = 0.3;

  return (
    <div id="new-polaris" className="bh-tech-subpage">
      <img src={Bg} alt="" className="modal-full-bg" />

      <motion.video
        src={VideoBg}
        className="modal-full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="100px" left="19px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '28px',
              left: '18px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            New Polaris™ Platform
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '72px',
              left: '18px',
              letterSpacing: '0.95px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            Delivering the full perspective demands{' '}
            <strong>our most intelligent platform ever</strong>
          </motion.div>
        </div>
      </header>

      <motion.div
        className="stat"
        id="stat-1"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: BASE_TIME + 1 * INTERVAL }}
      >
        <strong>16x</strong>
        <p>more capacity to execute advanced algorithms*</p>
      </motion.div>
      <motion.div
        className="stat"
        id="stat-2"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: BASE_TIME + 2 * INTERVAL }}
      >
        <p>Industry-leading</p>
        <strong>64-channel processing</strong>
      </motion.div>
      <motion.div
        className="stat"
        id="stat-3"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: BASE_TIME + 3 * INTERVAL }}
      >
        <strong>2x</strong>
        <p>computational capacity and speed*</p>
      </motion.div>
      <motion.div
        className="stat"
        id="stat-4"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: BASE_TIME + 4 * INTERVAL }}
      >
        <strong>2x</strong>
        <p>precision in 1.5-5kHz frequency bands*</p>
      </motion.div>
      <motion.div
        className="stat"
        id="stat-5"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: BASE_TIME + 5 * INTERVAL }}
      >
        <strong>On-board</strong>
        <p>Deep Neural Network processing</p>
      </motion.div>

      <motion.div
        className="footnote"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 3 }}
      >
        * Compared to Velox S™ platform
      </motion.div>
    </div>
  );
}
